import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, FormGroup, ControlLabel, Button } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';

import GroupSelect from '../common/GroupSelect';
import { sortFcdbFoodId } from '../../util/util';

import 'react-bootstrap-typeahead/css/Typeahead.css';

/**
 * Concerns of this component:
 *   control values in the forms (child components)
 *   to generate and pass query when submit.
 *   route to food detail when recordid is specified.
**/
class BasicFoodQueryBuilder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      query: this.props.urlQuery || '',
      group: this.props.selectedGroup || 'all',
    };

    this.routeToFoodDetail = this.routeToFoodDetail.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.setGroup = this.setGroup.bind(this);
  }

  // to update forms when navigated via history.
  componentWillReceiveProps(nextProps) {
    if(this.props !== nextProps) {
      this.setState({
        query: nextProps.urlQuery || '',
        group: nextProps.selectedGroup || 'all',
      });
    }
  }

  routeToFoodDetail(recordid) {
    this.props.history.push(`/search/food/${recordid}`);
  }

  handleSubmit(event) {
    event.preventDefault();

    // Typeahead onChange redirects only when an option is selected from the list.
    // This code covers when submit is triggered.
    if(this.props.foods
      .map(food => food.recordid.toLowerCase())
      .indexOf(this.state.query.toLowerCase()) >= 0) {
      this.routeToFoodDetail(this.state.query);
    }

    // onChangeQ etc does not push history. use multiPushInUrlQuery.
    this.props.handleSubmit({
      q: this.state.query,
      group: this.state.group === 'all' ? '' : this.state.group,
    });
  }

  setGroup(group) {
    this.setState({group: group});
  }

  render() {
    const { foods, groups } = this.props;
    return (
      <div className="BasicFoodQueryBuilder">
        <p>Provides the details of the amount of each nutrient in a food.</p>

        <form onSubmit={this.handleSubmit}>
          <Col sm={12} md={6}>
            <FormGroup controlId="query">
              <ControlLabel>Search for</ControlLabel>
              <Typeahead
                options={foods.sort(sortFcdbFoodId)}
                labelKey="recordid"
                placeholder="e.g. apple or A1014"
                onInputChange={(query) => {
                  // this makes it possible to control input.
                  // onChange only allows what's in options.
                  // use onInputChange to allow free text search.
                  this.setState({query});
                }}
                selected={this.state.query ? [this.state.query] : []}
                submitFormOnEnter
                minLength={2}
                emptyLabel=""
                onChange={(selected) => {
                  // navigate to food detail.
                  // onChange fires not only on option selection.
                  // make sure navigate happens only when an option is selected.
                  if(selected[0] !== undefined && typeof selected[0].recordid === 'string') {
                    this.routeToFoodDetail(selected[0].recordid);
                  }
                }}
              />
            </FormGroup>
          </Col>
          <Col sm={12} md={6}>
            <GroupSelect
              groups={groups}
              selected={this.state.group}
              setGroup={this.setGroup}/>
          </Col>
          <div className="searchButton">
            <Button type="submit" bsStyle="primary">GO</Button>
          </div>
        </form>

      </div>
    );
  }
}

BasicFoodQueryBuilder.propTypes = {
  history: PropTypes.object,
  foods: PropTypes.array.isRequired,
  groups: PropTypes.array.isRequired,
  urlQuery: PropTypes.string,
  selectedGroup: PropTypes.string,
  handleSubmit: PropTypes.func,
};

export default BasicFoodQueryBuilder;



// WEBPACK FOOTER //
// ./src/components/search/basicFood/BasicFoodQueryBuilder.js